import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, postData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import CircularProgress from '@mui/material/CircularProgress';
import BillPrint from '../sale/Bill';
import ReactDOM from 'react-dom';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import gender from './gender_looms_logo.png';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DoneAllIcon from '@mui/icons-material/DoneAll';

const NewSaleEdit = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate, roleName } = useAuth();
    const [selectedGWPorPWP, setSelectedGWPorPWP] = useState(false);

    const [selectedSalesMan, setSelectedSalesMan] = useState("");
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);

    const [selectedDiscType, setSelectedDiscType] = useState("");
    const [dropdownDiscTypeOptions, setDropdownDiscTypeOptions] = useState([]);

    const [selectedCardType, setSelectedCardType] = useState("");
    const [dropdownCardTypeOptions, setDropdownCardTypeOptions] = useState([]);

    const [showCardFields, setShowCardFields] = useState(false);
    const [showupiFields, setShowupiFields] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    useEffect(() => {
        fetchDropdownSalesManOptions();
        fetchDropdownCardTypeOptions();
        fetchDropdownDiscTypeOptions();
    }, []);

    const fetchDropdownSalesManOptions = () => {
        fetchData('SaleApi', `/SalesMan/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownSalesManOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Sales Man dropdown options:', error);
            });
    };

    const fetchDropdownDiscTypeOptions = () => {
        fetchData('SaleApi', `/DiscType/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownDiscTypeOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Disc Type dropdown options:', error);
            });
    };

    const fetchDropdownCardTypeOptions = () => {
        fetchData('SaleApi', `/CardType/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownCardTypeOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Card Type dropdown options:', error);
            });
    };

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    const [formData, setFormData] = useState([]);
    const [invoicedeatils, setInvoicedeatils] = useState([]);

    useEffect(() => {
        fetchData('SaleApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Sale);
                    setInvoicedeatils(response.response_data.SaleDetails);
                    setFormData(prevData => ({
                        ...prevData,
                        UpdatedBy: userId,
                    }));

                    setSelectedSalesMan(response.response_data.Sale.SalesManId);
                    setSelectedCardType(response.response_data.Sale.CardType);
                    setSelectedDiscType(response.response_data.Sale.DiscTypeId);
                    setSelectedGWPorPWP(response.response_data.Sale.GWPorPWPIncluded);
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);

    const handlePaymodeChange = (event) => {
        const selectedPaymode = Number(event.target.value); // convert string → number

        setFormData((prevData) => ({
            ...prevData,
            Paymode: selectedPaymode,
            DigitalAmount: selectedPaymode === 1 ? prevData.GrandTotal : 0,
            CashAmount: selectedPaymode === 2 ? prevData.GrandTotal : 0,
        }));
    };

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        if (name === 'GVAmount') {
            const gvamt = parseFloat(value) || 0;
            setFormData((prevData) => ({
                ...prevData,
                GVAmount: gvamt.toFixed(2),
                ModifiedBy: userId,
                SalesManId: selectedSalesMan,
                CardType: selectedCardType
            }));

            const AdditionalDisc = (formData.AdditionalDiscountPercentage) || 0;

            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2)
                let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
                let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                let grate = (rate - totdiscount).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!formData.GSTNumber) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = ((parseFloat(taxableamount) + parseFloat(gstAmount)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: (AdditionalDisc),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const AddiDiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.AdditionalDiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);

            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            const totdisc = parseFloat(DiscountAmount) + parseFloat(AddiDiscountAmount);
            totalCalculation(Quantity, Amount, totdisc, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvamt, CardAmount, UPIAmount);
        }
        else if (name === 'GSTNumber') {
            const gstno = value;
            setFormData((prevData) => ({
                ...prevData,
                GSTNumber: gstno,
                ModifiedBy: userId,
                SalesManId: selectedSalesMan,
                CardType: selectedCardType
            }));

            const AdditionalDisc = (formData.AdditionalDiscountPercentage) || 0;

            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2)
                let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2);
                let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                let grate = (rate - totdiscount).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!gstno) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = gstno.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = (parseFloat(taxableamount) + parseFloat(gstAmount)).toFixed(2);

                return {
                    ...item,
                    Amount: amount,
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: (AdditionalDisc),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const AddiDiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.AdditionalDiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            const totdisc = parseFloat(DiscountAmount) + parseFloat(AddiDiscountAmount);
            totalCalculation(Quantity, Amount, totdisc, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);

        }
        else if (name === 'CardAmount') {

            const cardAmount = parseFloat(value) || 0;
            setFormData((prevData) => ({
                ...prevData,
                CardAmount: cardAmount.toFixed(2),
                ModifiedBy: userId,
                SalesManId: selectedSalesMan,
                CardType: selectedCardType
            }));

            const AdditionalDisc = (formData.AdditionalDiscountPercentage) || 0;

            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2)
                let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2);
                let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                let grate = (rate - totdiscount).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!formData.GSTNumber) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: (AdditionalDisc),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const AddiDiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.AdditionalDiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            const totdisc = parseFloat(DiscountAmount) + parseFloat(AddiDiscountAmount);
            totalCalculation(Quantity, Amount, totdisc, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, cardAmount, UPIAmount);

        }
        else if (name === 'UPIAmount') {

            const upiAmount = parseFloat(value) || 0;
            setFormData((prevData) => ({
                ...prevData,
                UPIAmount: upiAmount.toFixed(2),
                ModifiedBy: userId,
                SalesManId: selectedSalesMan,
                CardType: selectedCardType
            }));
            const AdditionalDisc = (formData.AdditionalDiscountPercentage) || 0;

            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2)
                let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2);
                let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                let grate = (rate - totdiscount).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!formData.GSTNumber) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = ((parseFloat(taxableamount) + parseFloat(gstAmount)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: (AdditionalDisc),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const AddiDiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.AdditionalDiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const totdisc = parseFloat(DiscountAmount) + parseFloat(AddiDiscountAmount);
            totalCalculation(Quantity, Amount, totdisc, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, upiAmount);

        }
        else if (name === 'AdditionalDiscountPercentage') {

            const AdditionalDisc = parseFloat(value) || 0;
            setFormData((prevData) => ({
                ...prevData,
                AdditionalDiscountPercentage: AdditionalDisc,
                ModifiedBy: userId,
            }));


            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2);
                let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2);
                let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                let grate = (rate - totdiscount).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!formData.GSTNumber) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = (parseFloat(taxableamount) + parseFloat(gstAmount)).toFixed(2);

                return {
                    ...item,
                    Amount: amount,
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: (AdditionalDisc),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const AddiDiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.AdditionalDiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            const totdisc = parseFloat(DiscountAmount) + parseFloat(AddiDiscountAmount);
            totalCalculation(Quantity, Amount, totdisc, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);
        }
        else {

            setFormData((prevData) => ({
                ...prevData,
                [name]: type === 'checkbox' ? checked : value,
                SalesManId: selectedSalesMan,
                CardType: selectedCardType
            }));

        }

    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (!formData.CustomerName) {
            setErrorMessage('Customer Name is required !');
            setIsLoading(false);
            return;
        }

        if (!formData.ContactNumber) {
            setErrorMessage('Contact Number is required !');
            setIsLoading(false);
            return;
        }

        if (!selectedSalesMan) {
            setErrorMessage('Sales Man is required !');
            setIsLoading(false);
            return;
        }

        if (!invoicedeatils || invoicedeatils.length === 0) {
            setErrorMessage('Item Details are required!');
            setIsLoading(false);
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            ModifiedBy: userId,
            BranchId: branchId,
            CompanyId: companyId,
            SalesManId: selectedSalesMan,
            CardType: selectedCardType
        }));

        const CreateData = {
            Sale: formData,
            SaleDetails: invoicedeatils
        };

        // Validate form data here if needed
        updateData('SaleApi', `${id}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);

                if (response.response === 'Sale Updated Successfully') {
                    const SaleId = response.kotId;
                    //handlePrint(SaleId);
                    generateInvoice(SaleId);
                }
                history.push('/NewSaleIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    const removeRecord = (index) => {
        const isConfirmed = window.confirm("Are you sure you want to remove the record?");
        if (isConfirmed) {
            const updatedRecords = [...invoicedeatils];
            updatedRecords.splice(index, 1); // Remove the record at the specified index
            setInvoicedeatils(updatedRecords); // Update the state to reflect the removed record

            const Quantity = updatedRecords.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const AddiDiscountAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.AdditionalDiscountAmount), 0);
            const TaxableAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);

            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            const totdisc = parseFloat(DiscountAmount) + parseFloat(AddiDiscountAmount);
            totalCalculation(Quantity, Amount, totdisc, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);

        }

    };

    //Items
    const [itemsOptions, setItemsrOptions] = useState([]);
    const [selectedItems, setSelectedItem] = useState("");

    useEffect(() => {
        fetchItems();
    }, []);

    const fetchItems = async () => {
        try {
            const response = await fetchData('SaleApi', `/Item/${companyId}/${branchId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(item => ({
                    value: item.Id,
                    label: item.Code + '-' + item.Name
                }));
                setItemsrOptions(options);
                setItemDetails(response.response_data);
            }

            setFormData(prevData => ({
                ...prevData,
                BranchId: branchId,
                CompanyId: companyId,
                CreatedBy: userId,
            }));

        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    // FOR MODEL DATA (Invoice Details)
    const [modalData, setModalData] = useState({
        SlNo: '0',
        ItemName: '',
        ItemId: '',
        Quantity: '1',
        Rate: '',
        Amount: '',
        DiscountPercentage: '',
        DiscountAmount: '',
        HSNCode: '',
        GSTRate: '',
        TaxableAmount: '',
        CGSTAmount: '',
        SGSTAmount: '',
        IGSTAmount: '',
        TotalAmount: '',
        balanceStock: 0,
    });

    const closeModal = () => {
        setModalData({
            SlNo: '0',
            ItemName: '',
            ItemId: '',
            Quantity: '1',
            Rate: '',
            Amount: '',
            DiscountPercentage: '',
            DiscountAmount: '',
            HSNCode: '',
            GSTRate: '',
            TaxableAmount: '',
            CGSTAmount: '',
            SGSTAmount: '',
            IGSTAmount: '',
            TotalAmount: '',
            balanceStock: 0,
        });
        setSelectedItem();
        setIsModalOpen(false);
    };

    const saveModalData = () => {
        let isValid = true;
        let errors = "";
        setErrorMessageModel(errors);

        // Validation for ItemId
        if (!modalData.ItemId) {
            isValid = false;
            errors = "Item is required";
        }

        // Validation for Quantity
        if (!modalData.Quantity || isNaN(modalData.Quantity)) {
            isValid = false;
            errors = "Quantity must be a valid number";
        }

        if (modalData.Quantity > modalData.balanceStock) {
            isValid = false;
            errors = "Quantity exceeds available stock.";
        }


        if (isValid) {
            //setInvoicedeatils([...invoicedeatils, modalData]);
            const updatedInvoicedetails = [...invoicedeatils, modalData];
            const updatedInvoicedetailsSorted = updatedInvoicedetails.reverse();
            setInvoicedeatils(updatedInvoicedetailsSorted);

            setModalData({
                ...modalData,
                SlNo: '0',
                ItemName: '',
                ItemId: '',
                Quantity: '1',
                Rate: '',
                Amount: '',
                DiscountPercentage: '',
                DiscountAmount: '',
                HSNCode: '',
                GSTRate: '',
                TaxableAmount: '',
                CGSTAmount: '',
                SGSTAmount: '',
                IGSTAmount: '',
                TotalAmount: '',
                balanceStock: 0,
            });

            setSelectedItem(0);
            //closeModal();

            // Update the totals based on the updatedItemData
            const Quantity = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const AddiDiscountAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.AdditionalDiscountAmount), 0);
            const TaxableAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);

            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            const totdisc = parseFloat(DiscountAmount) + parseFloat(AddiDiscountAmount);
            totalCalculation(Quantity, Amount, totdisc, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);


        } else {

            console.log("Validation errors:", errors);
            setErrorMessageModel(errors);
        }

    };

    const totalCalculation = (Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvamt, CardAmount, UPIAmount) => {

        const gvAmount = parseFloat(gvamt) || 0;

        let netamount = parseFloat(TaxableAmount);
        let netAmt = netamount + parseFloat(CGSTAmount) + parseFloat(SGSTAmount) + parseFloat(IGSTAmount);
        let roundOffValue = Math.round(netAmt) - netAmt;
        let totalAmt = parseFloat((netAmt + roundOffValue)).toFixed(2);
        totalAmt = parseFloat(totalAmt - gvAmount).toFixed(2);
        let cashamt = parseFloat(totalAmt - CardAmount - UPIAmount).toFixed(2);

        setFormData((prevData) => ({
            ...prevData,
            TotalQuantity: Quantity,
            TotalAmount: Amount.toFixed(2),
            DiscountAmount: DiscountAmount.toFixed(2),
            TaxableAmount: TaxableAmount.toFixed(2),
            CGSTAmount: CGSTAmount.toFixed(2),
            SGSTAmount: SGSTAmount.toFixed(2),
            IGSTAmount: IGSTAmount.toFixed(2),
            RoundOff: roundOffValue.toFixed(2),
            GrandTotal: parseFloat(totalAmt).toFixed(2),
            CashAmount: parseFloat(cashamt).toFixed(2),
            GVAmount: gvAmount.toFixed(2),
            CardAmount: CardAmount.toFixed(2),
            UPIAmount: UPIAmount.toFixed(2),
            CashDiscount: 0,
            ModifiedBy: userId,
        }));
    };

    const [itemdetails, setItemDetails] = useState([]);
    const handleItemSelect = (selectedOption) => {
        setSelectedItem(selectedOption);
        setModalData({
            ...modalData,
            ItemName: selectedOption ? selectedOption.label : '',
            ItemId: selectedOption ? selectedOption.value : '',
        });

        // Use Array.prototype.find() to find the rate
        const selectedItemId = selectedOption ? selectedOption.value : '';
        const AdditionalDisc = (formData.AdditionalDiscountPercentage) || 0;

        const selectedItemDetail = itemdetails.find((itemDetail) => itemDetail.Id === selectedItemId);

        if (selectedItemDetail) {

            let quantity = parseFloat(modalData.Quantity) || 0;;
            let rate = parseFloat(selectedItemDetail.MRP.toFixed(2)) || 0;
            let gstrate = parseFloat(selectedItemDetail.GSTRate.toFixed(2)) || 0;
            let discountPercentage = parseFloat(selectedItemDetail.DiscountPercentage.toFixed(2)) || 0;

            let amount = (quantity * rate).toFixed(2);
            let discamt = ((rate * discountPercentage) / 100).toFixed(2)
            let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
            let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
            let grate = (rate - totdiscount).toFixed(2);
            let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
            const taxableamount = (quantity * salerate).toFixed(2);
            const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

            let cgst = 0;
            let sgst = 0;
            let igst = 0;

            if (!formData.GSTNumber) {
                cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            } else {
                const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                if (gstNumberPrefix !== branchstate) {
                    igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                } else {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                }
            }

            const totalAmount = (parseFloat(taxableamount) + parseFloat(gstAmount)).toFixed(2);

            setModalData({
                ...modalData,
                Rate: selectedItemDetail.MRP.toFixed(2), // Assuming Rate is a number
                GSTRate: selectedItemDetail.GSTRate.toFixed(2),
                HSNCode: selectedItemDetail.HSNCode,
                DiscountPercentage: selectedItemDetail.DiscountPercentage.toFixed(2),
                AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                AdditionalDiscountPercentage: (AdditionalDisc),
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
                Amount: amount,
                DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                TaxableAmount: parseFloat(taxableamount).toFixed(2),
                CGSTAmount: parseFloat(cgst).toFixed(2),
                SGSTAmount: parseFloat(sgst).toFixed(2),
                IGSTAmount: parseFloat(igst).toFixed(2),
                TotalAmount: parseFloat(totalAmount).toFixed(2),
                balanceStock: selectedItemDetail.balanceStock,
            });

        } else {
            // Handle the case where the item detail is not found
            setModalData({
                ...modalData,
                Rate: '0.00',
                GSTRate: '0.00',
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
                GSTRate: '0',
                HSNCode: '',
                DiscountPercentage: '',
                AdditionalDiscountPercentage: 0,
            });
        }
    };

    const [isValid, setIsValid] = useState(true);
    const handleModalInputChange = (e) => {
        const { name, value } = e.target;
        setModalData({
            ...modalData,
            [name]: value,
        });

        const intValue = parseInt(value, 10);

        if (intValue > modalData.balanceStock) {
            setIsValid(false);
        } else {
            setIsValid(true);
        }
        const AdditionalDisc = (formData.AdditionalDiscountPercentage) || 0;
        let quantity = parseFloat(value) || 0;
        let rate = parseFloat(modalData.Rate) || 0;
        let gstrate = parseFloat(modalData.GSTRate) || 0;
        let discountPercentage = parseFloat(modalData.DiscountPercentage) || 0;

        let amount = (quantity * rate).toFixed(2);
        let discamt = ((rate * discountPercentage) / 100).toFixed(2)
        let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
        let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
        let grate = (rate - totdiscount).toFixed(2);
        let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
        const taxableamount = (quantity * salerate).toFixed(2);
        const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

        let cgst = 0;
        let sgst = 0;
        let igst = 0;

        if (!formData.GSTNumber) {
            cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
        } else {
            const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

            if (gstNumberPrefix !== branchstate) {
                igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
            } else {
                cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            }
        }

        const totalAmount = (parseFloat(taxableamount) + parseFloat(gstAmount)).toFixed(2);

        setModalData({
            ...modalData,
            Quantity: quantity,
            Amount: amount,
            DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
            AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
            AdditionalDiscountPercentage: (AdditionalDisc),
            TaxableAmount: parseFloat(taxableamount).toFixed(2),
            CGSTAmount: parseFloat(cgst).toFixed(2),
            SGSTAmount: parseFloat(sgst).toFixed(2),
            IGSTAmount: parseFloat(igst).toFixed(2),
            TotalAmount: parseFloat(totalAmount).toFixed(2),
        });
    };

    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    // const generateInvoice = async (saleId) => {
    //     try {
    //         const response = await fetchData('SaleApi', `/SalePrint/${saleId}/${branchId}`, token);
    //         const labelData = response.response_data;

    //         if (!labelData?.SalePrint || !labelData?.SalePrintDetails) {
    //             throw new Error("Invalid invoice data.");
    //         }

    //         const header = labelData.SalePrint;
    //         const items = labelData.SalePrintDetails;

    //         const doc = new jsPDF({
    //             orientation: 'portrait',
    //             unit: 'mm',
    //             format: [80, 297]
    //         });

    //         let y = 6;

    //         doc.addImage(gender, 'PNG', 15, 2, 50, 20);
    //         y += 13;

    //         // Invoice Meta
    //         doc.setFontSize(6.5);
    //         const pageWidth = doc.internal.pageSize.getWidth();

    //         doc.setFont('helvetica', 'bold');
    //         doc.text('INVOICE', pageWidth / 2, y + 5, { align: 'center' });

    //         doc.setFont('helvetica', 'bold');
    //         const invNo = [header.BillPrefix, header.FinYear, header.BillNumber].filter(Boolean).join('/');
    //         doc.text(`Inv.No: ${invNo}`, 5, y + 8);
    //         doc.text(`Customer: ${header.CustomerName || ''}`, 5, y + 12);

    //         const billDate = header.BillDate || '';
    //         const createdDate = header.CreatedDate || '';
    //         //const formattedDate = billDate ? new Date(billDate).toLocaleDateString() : '';
    //         const formattedDate = billDate
    //             ? new Date(billDate).toLocaleDateString('en-GB', {
    //                 day: '2-digit',
    //                 month: 'short',
    //                 year: 'numeric'
    //             }).replace(/ /g, '-')
    //             : '';

    //         const formattedTime = createdDate ? new Date(createdDate).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '';

    //         doc.text(`Date: ${formattedDate}`, pageWidth - 5, y + 8, { align: 'right' });
    //         doc.text(`Time: ${formattedTime}`, pageWidth - 5, y + 12, { align: 'right' });

    //         y += 18;

    //         // Filter items
    //         const filteredItems = items.filter(item => (item.Quantity ?? 0) > 0 || (item.Total ?? 0) > 0);

    //         const itemRows = filteredItems.map(item => [
    //             { content: item.ItemName || '', styles: { cellWidth: 40, valign: 'top' } },
    //             { content: (item.Quantity ?? 0).toString(), styles: { halign: 'center' } },
    //             { content: (item.Rate ?? 0).toFixed(2), styles: { halign: 'right' } },
    //             { content: (item.TotalAmount ?? 0).toFixed(2), styles: { halign: 'right' } }
    //         ]);

    //         const totalQuantity = filteredItems.reduce((sum, item) => sum + (item.Quantity ?? 0), 0);

    //         itemRows.push([
    //             { content: 'Total', styles: { halign: 'right', fontStyle: 'bold' } },
    //             { content: totalQuantity.toString(), styles: { halign: 'center', fontStyle: 'bold' } },
    //             { content: '', styles: {} },
    //             { content: (header.GrandTotal ?? 0).toFixed(2), styles: { halign: 'right', fontStyle: 'bold' } }
    //         ]);

    //         autoTable(doc, {
    //             startY: y,
    //             margin: { left: 5 },
    //             head: [['NAME OF PRODUCT', 'QTY', 'RATE', 'TOTAL']],
    //             body: itemRows,
    //             styles: {
    //                 fontSize: 6.5,
    //                 textColor: [0, 0, 0],
    //                 cellPadding: { top: 0.5, bottom: 0.5, left: 1, right: 1 },
    //                 overflow: 'linebreak',
    //                 lineColor: [0, 0, 0], // ⬅️ border color black
    //             },
    //             theme: 'grid',
    //             headStyles: {
    //                 fillColor: [255, 255, 255],
    //                 textColor: [0, 0, 0],
    //                 fontStyle: 'bold',
    //                 lineColor: [0, 0, 0] // ⬅️ border color black for header
    //             },
    //             columnStyles: {
    //                 0: { cellWidth: 30 },
    //                 1: { cellWidth: 8 },
    //                 2: { cellWidth: 10 },
    //                 3: { cellWidth: 12 },
    //             },
    //         });


    //         let finalY = (doc.lastAutoTable?.finalY ?? y) + 3;

    //         // Tax summary
    //         const taxSummaryLines = [
    //             ['Taxable Amt', (header.TaxableAmount ?? 0).toFixed(2)],
    //             ['CGST Amt', (header.CGSTAmount ?? 0).toFixed(2)],
    //             ['SGST Amt', (header.SGSTAmount ?? 0).toFixed(2)],
    //             ['Round Off', (header.RoundOff ?? 0).toFixed(2)],
    //             ['Total Amt', (header.GrandTotal ?? 0).toFixed(2)],
    //         ];

    //         // Tax breakdown % table
    //         const taxGroups = {};
    //         filteredItems.forEach(item => {
    //             const gst = item.GSTRate ?? 0;
    //             if (!taxGroups[gst]) {
    //                 taxGroups[gst] = { amount: 0, cgst: 0, sgst: 0 };
    //             }
    //             taxGroups[gst].amount += item.TaxableAmount ?? 0;
    //             taxGroups[gst].cgst += item.CGSTAmount ?? 0;
    //             taxGroups[gst].sgst += item.SGSTAmount ?? 0;
    //         });

    //         const taxBreakdownRows = Object.entries(taxGroups).map(([percent, vals]) => ([
    //             percent,
    //             vals.amount.toFixed(2),
    //             vals.cgst.toFixed(2),
    //             vals.sgst.toFixed(2)
    //         ]));

    //         const totalRow = taxBreakdownRows.reduce((acc, row) => {
    //             for (let i = 1; i <= 3; i++) acc[i] += parseFloat(row[i]);
    //             return acc;
    //         }, ['Total', 0, 0, 0]).map((v, i) => i === 0 ? v : v.toFixed(2));

    //         taxBreakdownRows.push(totalRow);

    //         // Tax breakdown table with borders
    //         const leftX = 5;
    //         const rightX = 75;
    //         const rowHeight = 5;
    //         const colWidths = [8, 13, 13, 13];
    //         const colTitles = ['%', 'Amount', 'CGST', 'SGST'];

    //         doc.setFontSize(6.5);
    //         doc.setFont('helvetica', 'bold');
    //         doc.text('Tax Breakdown', leftX, finalY);

    //         let tableStartY = finalY + 4;
    //         let colX = leftX;

    //         colTitles.forEach((title, i) => {
    //             doc.rect(colX, tableStartY, colWidths[i], rowHeight);
    //             doc.text(title, colX + colWidths[i] / 2, tableStartY + 3.2, { align: 'center' });
    //             colX += colWidths[i];
    //         });

    //         doc.setFont('helvetica', 'normal');
    //         let currentY = tableStartY + rowHeight;

    //         taxBreakdownRows.forEach(row => {
    //             let rowX = leftX;
    //             row.forEach((cell, i) => {
    //                 doc.rect(rowX, currentY, colWidths[i], rowHeight);
    //                 doc.text(cell.toString(), rowX + colWidths[i] / 2, currentY + 3.2, { align: 'center' });
    //                 rowX += colWidths[i];
    //             });
    //             currentY += rowHeight;
    //         });

    //         let taxBreakdownBottomY = currentY;

    //         // // Right side: Tax Summary
    //         let summaryY = finalY;
    //         doc.setFont('helvetica', 'bold');
    //         taxSummaryLines.forEach(([label, value]) => {
    //             doc.text(`${label}: ${value}`, rightX, summaryY, { align: 'right' });
    //             summaryY += 4;
    //         });

    //         finalY = Math.max(taxBreakdownBottomY, summaryY) + 2;

    //         // // Net Total
    //         // doc.setFontSize(7.5);
    //         // doc.text(`INR ${(header.GrandTotal ?? 0).toFixed(2)}`, rightX, finalY, { align: 'right' });
    //         // // Total Discount
    //         // doc.setFontSize(7.5);
    //         // doc.text(`INR ${(header.DiscountAmount ?? 0).toFixed(2)}`, rightX, finalY, { align: 'right' });
    //         // Net Total
    //         doc.setFontSize(7.5);
    //         doc.setFont('helvetica', 'bold');
    //         doc.text(`INR: ${(header.GrandTotal ?? 0).toFixed(2)}`, rightX, finalY, { align: 'right' });

    //         // Discount
    //         finalY += 4; // move 4mm down (adjust spacing as needed)
    //         doc.setFontSize(7.5);
    //         doc.setFont('helvetica', 'normal');
    //         doc.text(`Discount: ${(header.DiscountAmount ?? 0).toFixed(2)}`, rightX, finalY, { align: 'right' });


    //         // Policies
    //         const marginX = 5;
    //         const textWidth = 70;
    //         currentY = finalY + 4;

    //         doc.setFontSize(5);
    //         doc.setFont("helvetica", "bold");

    //         const policy1 = "Exchange Policy for undergarments: For hygiene reason undergarments will not be exchanged or returned.";
    //         const policy2 = "Exchange Policy for Other items: Exchange is only applicable within 7 days from the billing date. Only items with intact original tags and a valid bill will be considered for exchange.";
    //         const policy3 = "Exchange Policy for Items: Exchange is only applicable only at respective stores.";

    //         const lines1 = doc.splitTextToSize(policy1, textWidth);
    //         doc.text(lines1, marginX, currentY);
    //         currentY += lines1.length * 2;

    //         const lines2 = doc.splitTextToSize(policy2, textWidth);
    //         doc.text(lines2, marginX, currentY);
    //         currentY += lines2.length * 2;

    //         const lines3 = doc.splitTextToSize(policy3, textWidth);
    //         doc.text(lines3, marginX, currentY);
    //         currentY += lines3.length * 2;

    //         finalY = currentY + 2; // SMALL gap before footer

    //         // Footer
    //         const centerX = pageWidth / 2;
    //         // doc.setFontSize(6);
    //         // doc.text('CUSTOMER CARE: 0484 4712 91 / 9995152525', centerX, finalY, { align: 'center' });
    //         // const addressLines = doc.splitTextToSize(header.AddressLine || '', 70); // 70 is max width in mm
    //         // addressLines.forEach((line, index) => {
    //         //     doc.text(line, centerX, finalY + 3 + index * 3, { align: 'center' }); // 4 is line height
    //         // });

    //         // make sure it's normal, not bold
    //         doc.setFont('helvetica', 'bold');
    //         doc.setFontSize(6);

    //         doc.text('CUSTOMER CARE: 9995152525', centerX, finalY, { align: 'center' });

    //         const addressLines = doc.splitTextToSize(header.AddressLine || '', 70);
    //         addressLines.forEach((line, index) => {
    //             doc.text(line, centerX, finalY + 3 + index * 3, { align: 'center' });
    //         });

    //         doc.text(`GSTIN: ${header.CompanyGSTNumber || ''} `, centerX, finalY + 9, { align: 'center' });

    //         finalY += 12;
    //         doc.text(`Sales Person: ${header.SalesPersonName || ''}`, 5, finalY);
    //         doc.text(`User Name: ${header.UserName || ''}`, 5, finalY + 4);

    //         finalY += 8;
    //         doc.setFont('helvetica', 'bold');
    //         doc.setFontSize(6.5);
    //         doc.text('THANK YOU - VISIT AGAIN', 40, finalY + 4, { align: 'center' });

    //         // Save PDF
    //         //doc.save(`invoice_${invNo || saleId}.pdf`);

    //         // Generate PDF as blob and open in new tab for printing
    //         const blob = doc.output('blob');
    //         const blobUrl = URL.createObjectURL(blob);
    //         const printWindow = window.open(blobUrl, '_blank');

    //         // Auto-trigger the print dialog once the PDF is loaded
    //         if (printWindow) {
    //             printWindow.onload = function () {
    //                 printWindow.focus();
    //                 printWindow.print();
    //             };
    //         }

    //     } catch (err) {
    //         console.error("Error generating invoice:", err);
    //     }
    // };

    const generateInvoice = async (saleId) => {
        try {
            const response = await fetchData('SaleApi', `/SalePrint/${saleId}/${branchId}`, token);
            const labelData = response.response_data;

            if (!labelData?.SalePrint || !labelData?.SalePrintDetails) {
                throw new Error("Invalid invoice data.");
            }

            const header = labelData.SalePrint;
            const items = labelData.SalePrintDetails;

            const doc = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: [80, 297]
            });

            let y = 6;

            doc.addImage(gender, 'PNG', 15, 2, 50, 20);
            y += 13;

            // Invoice Meta
            doc.setFontSize(6.5);
            const pageWidth = doc.internal.pageSize.getWidth();

            doc.setFont('helvetica', 'bold');
            doc.text('INVOICE', pageWidth / 2, y + 5, { align: 'center' });

            doc.setFont('helvetica', 'bold');
            const invNo = [header.BillPrefix, header.FinYear, header.BillNumber].filter(Boolean).join('/');
            doc.text(`Inv.No: ${invNo}`, 5, y + 8);
            doc.text(`Customer: ${header.CustomerName || ''}`, 5, y + 12);

            const billDate = header.BillDate || '';
            const createdDate = header.CreatedDate || '';
            //const formattedDate = billDate ? new Date(billDate).toLocaleDateString() : '';
            const formattedDate = billDate
                ? new Date(billDate).toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                }).replace(/ /g, '-')
                : '';

            const formattedTime = createdDate ? new Date(createdDate).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '';

            doc.text(`Date: ${formattedDate}`, pageWidth - 5, y + 8, { align: 'right' });
            doc.text(`Time: ${formattedTime}`, pageWidth - 5, y + 12, { align: 'right' });

            y += 18;

            // Filter items
            const filteredItems = items.filter(item => (item.Quantity ?? 0) > 0 || (item.Total ?? 0) > 0);

            const itemRows = filteredItems.map(item => [
                { content: item.ItemName || '', styles: { cellWidth: 30, valign: 'top' } },
                { content: (item.Quantity ?? 0).toString(), styles: { halign: 'center' } },
                { content: (item.MRP ?? 0).toFixed(2), styles: { halign: 'right' } },
                { content: (item.Rate ?? 0).toFixed(2), styles: { halign: 'right' } },
                { content: (item.TotalAmount ?? 0).toFixed(2), styles: { halign: 'right' } }
            ]);

            const totalQuantity = filteredItems.reduce((sum, item) => sum + (item.Quantity ?? 0), 0);

            itemRows.push([
                { content: 'Total', styles: { halign: 'right', fontStyle: 'bold' } },
                { content: totalQuantity.toString(), styles: { halign: 'center', fontStyle: 'bold' } },
                { content: '', styles: {} },
                { content: '', styles: {} },
                { content: (header.GrandTotal ?? 0).toFixed(2), styles: { halign: 'right', fontStyle: 'bold' } }
            ]);

            autoTable(doc, {
                startY: y,
                margin: { left: 5 },
                head: [['NAME OF PRODUCT', 'QTY', 'MRP', 'RATE', 'TOTAL']],
                body: itemRows,
                styles: {
                    fontSize: 6.5,
                    textColor: [0, 0, 0],
                    cellPadding: { top: 0.5, bottom: 0.5, left: 1, right: 1 },
                    overflow: 'linebreak',
                    lineColor: [0, 0, 0], // ⬅️ border color black
                },
                theme: 'grid',
                headStyles: {
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontStyle: 'bold',
                    lineColor: [0, 0, 0] // ⬅️ border color black for header
                },
                columnStyles: {
                    0: { cellWidth: 22 },
                    1: { cellWidth: 8 },
                    2: { cellWidth: 10 },
                    3: { cellWidth: 10 },
                    4: { cellWidth: 12 },
                },
            });


            let finalY = (doc.lastAutoTable?.finalY ?? y) + 3;

            // Tax summary
            const taxSummaryLines = [
                ['Taxable Amt', (header.TaxableAmount ?? 0).toFixed(2)],
                ['CGST Amt', (header.CGSTAmount ?? 0).toFixed(2)],
                ['SGST Amt', (header.SGSTAmount ?? 0).toFixed(2)],
                ['Round Off', (header.RoundOff ?? 0).toFixed(2)],
                ['Total Amt', (header.GrandTotal ?? 0).toFixed(2)],
            ];

            // Tax breakdown % table
            const taxGroups = {};
            filteredItems.forEach(item => {
                const gst = item.GSTRate ?? 0;
                if (!taxGroups[gst]) {
                    taxGroups[gst] = { amount: 0, cgst: 0, sgst: 0 };
                }
                taxGroups[gst].amount += item.TaxableAmount ?? 0;
                taxGroups[gst].cgst += item.CGSTAmount ?? 0;
                taxGroups[gst].sgst += item.SGSTAmount ?? 0;
            });

            const taxBreakdownRows = Object.entries(taxGroups).map(([percent, vals]) => ([
                percent,
                vals.amount.toFixed(2),
                vals.cgst.toFixed(2),
                vals.sgst.toFixed(2)
            ]));

            const totalRow = taxBreakdownRows.reduce((acc, row) => {
                for (let i = 1; i <= 3; i++) acc[i] += parseFloat(row[i]);
                return acc;
            }, ['Total', 0, 0, 0]).map((v, i) => i === 0 ? v : v.toFixed(2));

            taxBreakdownRows.push(totalRow);

            // Tax breakdown table with borders
            const leftX = 5;
            const rightX = 75;
            const rowHeight = 5;
            const colWidths = [8, 13, 13, 13];
            const colTitles = ['%', 'Amount', 'CGST', 'SGST'];

            doc.setFontSize(6.5);
            doc.setFont('helvetica', 'bold');
            doc.text('Tax Breakdown', leftX, finalY);

            let tableStartY = finalY + 4;
            let colX = leftX;

            colTitles.forEach((title, i) => {
                doc.rect(colX, tableStartY, colWidths[i], rowHeight);
                doc.text(title, colX + colWidths[i] / 2, tableStartY + 3.2, { align: 'center' });
                colX += colWidths[i];
            });

            doc.setFont('helvetica', 'normal');
            let currentY = tableStartY + rowHeight;

            taxBreakdownRows.forEach(row => {
                let rowX = leftX;
                row.forEach((cell, i) => {
                    doc.rect(rowX, currentY, colWidths[i], rowHeight);
                    doc.text(cell.toString(), rowX + colWidths[i] / 2, currentY + 3.2, { align: 'center' });
                    rowX += colWidths[i];
                });
                currentY += rowHeight;
            });

            let taxBreakdownBottomY = currentY;

            // // Right side: Tax Summary
            let summaryY = finalY;
            doc.setFont('helvetica', 'bold');
            taxSummaryLines.forEach(([label, value]) => {
                doc.text(`${label}: ${value}`, rightX, summaryY, { align: 'right' });
                summaryY += 4;
            });

            finalY = Math.max(taxBreakdownBottomY, summaryY) + 2;

            // // Net Total
            // doc.setFontSize(7.5);
            // doc.text(`INR ${(header.GrandTotal ?? 0).toFixed(2)}`, rightX, finalY, { align: 'right' });
            // // Total Discount
            // doc.setFontSize(7.5);
            // doc.text(`INR ${(header.DiscountAmount ?? 0).toFixed(2)}`, rightX, finalY, { align: 'right' });
            // Net Total
            doc.setFontSize(7.5);
            doc.setFont('helvetica', 'bold');
            doc.text(`INR: ${(header.GrandTotal ?? 0).toFixed(2)}`, rightX, finalY, { align: 'right' });

            // Discount
            finalY += 4; // move 4mm down (adjust spacing as needed)
            doc.setFontSize(7.5);
            doc.setFont('helvetica', 'normal');
            doc.text(`Discount: ${(header.DiscountAmount ?? 0).toFixed(2)}`, rightX, finalY, { align: 'right' });


            // Policies
            const marginX = 5;
            const textWidth = 70;
            currentY = finalY + 4;

            doc.setFontSize(5);
            doc.setFont("helvetica", "bold");

            const policy1 = "Exchange Policy for undergarments: For hygiene reason undergarments will not be exchanged or returned.";
            const policy2 = "Exchange Policy for Other items: Exchange is only applicable within 7 days from the billing date. Only items with intact original tags and a valid bill will be considered for exchange.";
            const policy3 = "Exchange Policy for Items: Exchange is only applicable only at respective stores.";

            const lines1 = doc.splitTextToSize(policy1, textWidth);
            doc.text(lines1, marginX, currentY);
            currentY += lines1.length * 2;

            const lines2 = doc.splitTextToSize(policy2, textWidth);
            doc.text(lines2, marginX, currentY);
            currentY += lines2.length * 2;

            const lines3 = doc.splitTextToSize(policy3, textWidth);
            doc.text(lines3, marginX, currentY);
            currentY += lines3.length * 2;

            finalY = currentY + 2; // SMALL gap before footer

            // Footer
            const centerX = pageWidth / 2;
            // doc.setFontSize(6);
            // doc.text('CUSTOMER CARE: 0484 4712 91 / 9995152525', centerX, finalY, { align: 'center' });
            // const addressLines = doc.splitTextToSize(header.AddressLine || '', 70); // 70 is max width in mm
            // addressLines.forEach((line, index) => {
            //     doc.text(line, centerX, finalY + 3 + index * 3, { align: 'center' }); // 4 is line height
            // });

            // make sure it's normal, not bold
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(6);

            doc.text('CUSTOMER CARE: 9995152525', centerX, finalY, { align: 'center' });

            const addressLines = doc.splitTextToSize(header.AddressLine || '', 70);
            addressLines.forEach((line, index) => {
                doc.text(line, centerX, finalY + 3 + index * 3, { align: 'center' });
            });

            doc.text(`GSTIN: ${header.CompanyGSTNumber || ''} `, centerX, finalY + 9, { align: 'center' });

            finalY += 12;
            doc.text(`Sales Person: ${header.SalesPersonName || ''}`, 5, finalY);
            doc.text(`User Name: ${header.UserName || ''}`, 5, finalY + 4);

            finalY += 8;
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(6.5);
            doc.text('THANK YOU - VISIT AGAIN', 40, finalY + 4, { align: 'center' });

            // Save PDF
            //doc.save(`invoice_${invNo || saleId}.pdf`);

            // Generate PDF as blob and open in new tab for printing
            const blob = doc.output('blob');
            const blobUrl = URL.createObjectURL(blob);
            const printWindow = window.open(blobUrl, '_blank');

            // Auto-trigger the print dialog once the PDF is loaded
            if (printWindow) {
                printWindow.onload = function () {
                    printWindow.focus();
                    printWindow.print();
                };
            }

        } catch (err) {
            console.error("Error generating invoice:", err);
        }
    };

    const handleEdit = (index, field, value) => {
        setInvoicedeatils((prev = []) => {
            // ===== UPDATE ITEM VALUE =====
            const updatedItems = prev.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            );

            const gvamt = parseFloat(formData?.GVAmount) || 0;

            // ===== RECALCULATE EACH ITEM =====
            const updatedItemData = updatedItems.map((item) => {
                const rate = parseFloat(item?.Rate) || 0;
                const gstrate = parseFloat(item?.GSTRate) || 0;
                const discountPct = parseFloat(item?.DiscountPercentage) || 0;
                const additionalPct = (item?.AdditionalDiscountPercentage) || 0;
                const quantity = parseFloat(item?.Quantity) || 0;

                // Base amount
                const amount = quantity * rate;

                // Discounts (per unit)
                const discAmtPerUnit = (rate * discountPct) / 100;
                const addlDiscAmtPerUnit = (rate * additionalPct) / 100;
                const totalDiscPerUnit = discAmtPerUnit + addlDiscAmtPerUnit;

                // Net & sale rate
                const netRate = rate - totalDiscPerUnit;
                const saleRate = netRate / (1 + gstrate / 100);

                // Taxable & GST
                const taxableAmount = quantity * saleRate;
                let cgst = 0, sgst = 0, igst = 0;

                const gstNumber = formData?.GSTNumber?.toString() || "";
                if (!gstNumber) {
                    // No GST number → CGST + SGST
                    cgst = (taxableAmount * (gstrate / 2)) / 100;
                    sgst = (taxableAmount * (gstrate / 2)) / 100;
                } else {
                    const gstPrefix = gstNumber.substring(0, 2);
                    if (gstPrefix !== branchstate) {
                        igst = (taxableAmount * gstrate) / 100; // Inter-state
                    } else {
                        cgst = (taxableAmount * (gstrate / 2)) / 100;
                        sgst = (taxableAmount * (gstrate / 2)) / 100;
                    }
                }

                const totalAmount = (taxableAmount + cgst + sgst + igst);

                return {
                    ...item,
                    Amount: amount.toFixed(2),
                    DiscountAmount: (discAmtPerUnit * quantity).toFixed(2),
                    AdditionalDiscountAmount: (addlDiscAmtPerUnit * quantity).toFixed(2),
                    AdditionalDiscountPercentage: additionalPct,
                    TaxableAmount: taxableAmount.toFixed(2),
                    CGSTAmount: cgst.toFixed(2),
                    SGSTAmount: sgst.toFixed(2),
                    IGSTAmount: igst.toFixed(2),
                    TotalAmount: totalAmount.toFixed(2),
                };
            });

            // ===== GRAND TOTALS =====
            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseFloat(item?.Quantity) || 0;
                    acc.Amount += parseFloat(item?.Amount) || 0;
                    acc.DiscountAmount += parseFloat(item?.DiscountAmount) || 0;
                    acc.AddiDiscountAmount += parseFloat(item?.AdditionalDiscountAmount) || 0;
                    acc.TaxableAmount += parseFloat(item?.TaxableAmount) || 0;
                    acc.CGSTAmount += parseFloat(item?.CGSTAmount) || 0;
                    acc.SGSTAmount += parseFloat(item?.SGSTAmount) || 0;
                    acc.IGSTAmount += parseFloat(item?.IGSTAmount) || 0;
                    acc.TotalAmount += parseFloat(item?.TotalAmount) || 0;
                    return acc;
                },
                {
                    Quantity: 0,
                    Amount: 0,
                    DiscountAmount: 0,
                    AddiDiscountAmount: 0,
                    TaxableAmount: 0,
                    CGSTAmount: 0,
                    SGSTAmount: 0,
                    IGSTAmount: 0,
                    TotalAmount: 0,
                }
            );

            // ===== ADD PAYMENT DATA =====
            const CardAmount = parseFloat(formData?.CardAmount) || 0;
            const UPIAmount = parseFloat(formData?.UPIAmount) || 0;
            const totalDiscount = totals.DiscountAmount + totals.AddiDiscountAmount;

            // ===== FINAL CALL =====
            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totalDiscount,
                totals.TaxableAmount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                gvamt,
                CardAmount,
                UPIAmount
            );

            // ✅ Return updated items as new state
            return updatedItemData;
        });
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '100%' }}>

                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.2em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                    `}
                </style>

                <div className="w-full mb-2 flex">
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}> Sale - Edit</h6>

                    <Button
                        style={{ marginLeft: '8px', color: 'darkgreen' }}
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        <DoneAllIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} /> {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>Update</b>}
                    </Button>

                    <Button
                        component={Link}
                        to="/NewSaleIndex"
                        className="linkcolor"
                        style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                    >
                        <ArrowCircleLeftIcon style={{ color: 'darkred', fontWeight: 'bolder' }} /> Back To List
                    </Button>

                </div>
                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>

                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="w-full mb-4 flex" style={{ marginTop: '-1.50%' }}>
                    <div className="container mx-auto mt-2 p-4 max-w-screen-md bg-tabcolor rounded-lg shadow-lg p-6" style={{ backgroundColor: 'rgba(255, 255, 255, 0.5)', maxHeight: '550px', overflowY: 'auto', maxWidth: '100%' }}>

                        <div className="w-full mb-2 flex" style={{ marginTop: '-1.25%' }}>

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-3/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Customer Name
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.CustomerName}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="CUSTOMER NAME"
                                        name='CustomerName'
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-3/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Customer Name
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.CustomerName}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="CUSTOMER NAME"
                                        name='CustomerName'
                                    />
                                </div>

                            )}

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Bill Date
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formatDateForInput(formData.BillDate)}
                                        onChange={handleChange}
                                        type="date"
                                        name='BillDate'
                                        disabled
                                    />
                                </div>

                            ) : (

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Bill Date
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formatDateForInput(formData.BillDate)}
                                        onChange={handleChange}
                                        type="date"
                                        name='BillDate'
                                    />
                                </div>
                            )}

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Bill Number
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.BillNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="BILL NUMBER"
                                        name='BillNumber'
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Bill Number
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.BillNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="BILL NUMBER"
                                        name='BillNumber'
                                        readOnly
                                    />
                                </div>
                            )}

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                    Total Qty
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.TotalQuantity}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="TOTAL QUANTITY"
                                    name='TotalQuantity'
                                    readOnly
                                />
                            </div>

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        ADDT'L. DISC Type
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        className={`custom-select ${selectedDiscType ? 'fade-in' : 'fade-in'}`}
                                        style={{ height: '30px', fontSize: '12px' }} // Direct height control
                                        value={selectedDiscType}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSelectedDiscType(selectedValue);
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                DiscTypeId: selectedValue,
                                            }));
                                        }}
                                        disabled
                                    >
                                        <option value="">Disc Type</option>
                                        {dropdownDiscTypeOptions.map((category) => (
                                            <option key={category.Id} value={category.Id}>
                                                {category.Name}
                                            </option>
                                        ))}
                                    </select>

                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        ADDT'L. DISC Type
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        className={`custom-select ${selectedDiscType ? 'fade-in' : 'fade-in'}`}
                                        style={{ height: '30px', fontSize: '12px' }} // Direct height control
                                        value={selectedDiscType}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSelectedDiscType(selectedValue);
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                DiscTypeId: selectedValue,
                                            }));
                                        }}
                                    >
                                        <option value="">Disc Type</option>
                                        {dropdownDiscTypeOptions.map((category) => (
                                            <option key={category.Id} value={category.Id}>
                                                {category.Name}
                                            </option>
                                        ))}
                                    </select>

                                </div>
                            )}

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        ADDT'L. Disc %
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.AdditionalDiscountPercentage}
                                        onChange={handleChange}
                                        type="number"
                                        placeholder="Disc %"
                                        style={{ textAlign: 'right' }}
                                        name='AdditionalDiscountPercentage'
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        ADDT'L. Disc %
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.AdditionalDiscountPercentage}
                                        onChange={handleChange}
                                        type="number"
                                        placeholder="Disc %"
                                        style={{ textAlign: 'right' }}
                                        name='AdditionalDiscountPercentage'
                                    />
                                </div>
                            )}

                        </div>

                        <div className="w-full mb-4 flex" style={{ marginTop: '-0.50%' }}>
                            {roleName !== "SuperAdmin" ? (
                                <div className="w-3/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Address
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.CustomerAddress}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Address"
                                        name='CustomerAddress'
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-3/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Address
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.CustomerAddress}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Address"
                                        name='CustomerAddress'
                                    />
                                </div>
                            )}


                            {roleName !== "SuperAdmin" ? (
                                <div className="w-2/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        GST Number
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.GSTNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="GST Number"
                                        name='GSTNumber'
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-2/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        GST Number
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.GSTNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="GST Number"
                                        name='GSTNumber'
                                    />
                                </div>
                            )}

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Phone No
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.ContactNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="PHONE NUMBER"
                                        name='ContactNumber'
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Phone No
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.ContactNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="PHONE NUMBER"
                                        name='ContactNumber'
                                    />
                                </div>

                            )}


                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Sales Man
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        className={`custom-select ${selectedSalesMan ? 'fade-in' : 'fade-in'}`}
                                        style={{ height: '30px', fontSize: '12px' }} // Direct height control
                                        value={selectedSalesMan}
                                        // onChange={(e) => setSelectedSalesMan(e.target.value)}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSelectedSalesMan(selectedValue);
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                SalesManId: selectedValue,
                                            }));
                                        }}
                                        disabled
                                    >
                                        <option value="">Select Sales Man</option>
                                        {dropdownSalesManOptions.map((category) => (
                                            <option key={category.Id} value={category.Id}>
                                                {category.Name}
                                            </option>
                                        ))}
                                    </select>

                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Sales Man
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        className={`custom-select ${selectedSalesMan ? 'fade-in' : 'fade-in'}`}
                                        style={{ height: '30px', fontSize: '12px' }} // Direct height control
                                        value={selectedSalesMan}
                                        // onChange={(e) => setSelectedSalesMan(e.target.value)}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSelectedSalesMan(selectedValue);
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                SalesManId: selectedValue,
                                            }));
                                        }}
                                    >
                                        <option value="">Select Sales Man</option>
                                        {dropdownSalesManOptions.map((category) => (
                                            <option key={category.Id} value={category.Id}>
                                                {category.Name}
                                            </option>
                                        ))}
                                    </select>

                                </div>
                            )}
                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="yes-no-select" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        GWP/PWP
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        id="yes-no-select"
                                        className={`custom-select ${selectedGWPorPWP ? 'fade-in' : 'fade-in'}`}
                                        style={{ height: '30px', fontSize: '12px' }} // Direct height control
                                        value={selectedGWPorPWP}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value === "true"; // Convert string "true"/"false" to boolean
                                            setSelectedGWPorPWP(selectedValue); // Update state with the selected value
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                GWPorPWPIncluded: selectedValue, // Update form data with the selected value
                                            }));
                                        }}
                                        disabled

                                    >
                                        <option value={true}>YES</option>
                                        <option value={false}>NO</option>
                                    </select>
                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="yes-no-select" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        GWP/PWP
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        id="yes-no-select"
                                        className={`custom-select ${selectedGWPorPWP ? 'fade-in' : 'fade-in'}`}
                                        style={{ height: '30px', fontSize: '12px' }} // Direct height control
                                        value={selectedGWPorPWP}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value === "true"; // Convert string "true"/"false" to boolean
                                            setSelectedGWPorPWP(selectedValue); // Update state with the selected value
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                GWPorPWPIncluded: selectedValue, // Update form data with the selected value
                                            }));
                                        }}

                                    >
                                        <option value={true}>YES</option>
                                        <option value={false}>NO</option>
                                    </select>
                                </div>
                            )}
                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                    Total
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={invoicedeatils
                                        .reduce((sum, item) => sum + Number(item.TotalAmount || 0), 0)
                                        .toFixed(2)}
                                    type="text"
                                    placeholder="GRAND TOTAL"
                                    name='GrandTotal'
                                    readOnly
                                    style={{ textAlign: 'right', fontWeight: 'bold', color: 'darkgreen' }}
                                />
                            </div>

                        </div>

                        <div className="w-full mb-2 flex" style={{ marginTop: '-1.50%' }}>
                            {/* Item Name */}
                            <div className="w-1/2 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Weightage" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                    Item Name
                                </label>
                                <Select
                                    value={selectedItems}
                                    onChange={handleItemSelect}
                                    options={itemsOptions}
                                    placeholder="Items"
                                    isSearchable
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            minHeight: "30px",   // same as your inputs
                                            height: "30px",
                                            fontSize: "14px",
                                        }),
                                        valueContainer: (base) => ({
                                            ...base,
                                            height: "30px",      // keeps text aligned properly
                                            padding: "0 6px",
                                        }),
                                        indicatorsContainer: (base) => ({
                                            ...base,
                                            height: "30px",      // makes dropdown arrow align
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            zIndex: 1301,
                                            fontSize: "14px",
                                        }),

                                        menuPortal: (provided) => ({
                                            ...provided,
                                            zIndex: 9999, // Ensures dropdown is above everything
                                        }),
                                    }}
                                    menuPortalTarget={document.body} // Required for zIndex to work
                                />
                            </div>

                            {/* Quantity */}
                            <div className="w-1/7 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="MinimumStock" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                    Quantity
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right h-8"
                                    type="number"
                                    name="Quantity"
                                    placeholder="Quantity"
                                    value={modalData.Quantity}
                                    onChange={handleModalInputChange}
                                    max={modalData.balanceStock}
                                    min={1}
                                />
                                {!isValid && (
                                    <p className="text-red-500 text-xs italic">
                                        Quantity exceeds available stock.
                                    </p>
                                )}
                            </div>

                            <button
                                className="bg-green-500 hover:bg-green-600 text-white text-xs font-semibold px-3 py-1 rounded-full shadow-md transition duration-200"
                                onClick={saveModalData}
                                style={{ marginLeft: '10px', marginTop: '25px', width: '80px', height: '30px', cursor: 'pointer' }}
                            >
                                Add
                            </button>

                            <div>
                                {/* Radio buttons */}
                                <div
                                    className="flex justify-end items-end ml-auto"
                                    style={{ marginTop: "22px" }}
                                >
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 font-bold mr-0"
                                        style={{ marginLeft: "12px" }}
                                    >
                                        <input
                                            type="radio"
                                            name="Paymode"
                                            value="1"
                                            checked={formData.Paymode === 1}
                                            onChange={handlePaymodeChange}
                                        />
                                        <span style={{ color: "blue", fontSize: "12px", marginLeft: '5px' }}>Digital</span>
                                    </label>
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 font-bold mr-0"
                                        style={{ marginLeft: "12px" }}
                                    >
                                        <input
                                            type="radio"
                                            name="Paymode"
                                            value="0"
                                            checked={formData.Paymode === 0}
                                            onChange={handlePaymodeChange}
                                        />
                                        <span style={{ color: "brown", fontSize: "12px", marginLeft: '5px' }}>Cash</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="w-full mb-2 flex" style={{ marginTop: '-0.25%' }}>
                            <div className="w-full mb-2 flex">
                                <TableContainer component={Paper}>
                                    <table className="table">
                                        <thead>
                                            <tr style={{ backgroundColor: '#A1D6B2' }}>
                                                <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', color: 'white', fontFamily: 'monospace' }}>Item Name</th>
                                                <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', textAlign: 'center', color: 'white', fontFamily: 'monospace' }}>Quantity</th>
                                                <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', textAlign: 'right', color: 'white', fontFamily: 'monospace' }}>Sale Price</th>
                                                <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', textAlign: 'right', color: 'white', fontFamily: 'monospace' }}>Disc %</th>
                                                <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', textAlign: 'right', color: 'white', fontFamily: 'monospace' }}> Addt'l Disc % </th>
                                                <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', textAlign: 'right', color: 'white', fontFamily: 'monospace' }}>Amount</th>
                                                {roleName == "SuperAdmin" && (
                                                    <th style={{ padding: '2px', backgroundColor: '#27445D', textAlign: 'right', textTransform: 'uppercase', fontSize: '13px', color: 'white', fontFamily: 'monospace' }}>Action</th>
                                                )}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {invoicedeatils.map((invdetail, index) => (
                                                <tr key={index} className={invdetail.ColorCode === '#ffffff' ? 'white-row' : ''} style={{ width: '100%' }}>
                                                    <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', fontSize: '12px', width: '45%', fontWeight: 'bold' }}>{invdetail.ItemName}</td>
                                                    <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', fontSize: '12px', width: '10%', fontWeight: 'bold', textAlign: 'center' }}>
                                                        <input
                                                            type="number"
                                                            onChange={(e) =>
                                                                handleEdit(index, "Quantity", e.target.value)
                                                            }
                                                            value={invdetail.Quantity}
                                                            style={{ width: "100%", fontSize: "13px", fontWeight: 'bold', padding: "4px", textAlign: 'right', backgroundColor: '#F7ECDE' }}
                                                        />
                                                    </td>
                                                    <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', fontSize: '12px', width: '10%', fontWeight: 'bold', textAlign: 'right' }}>{invdetail.Rate}</td>
                                                    <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', fontSize: '12px', width: '10%', fontWeight: 'bold', textAlign: 'right' }}>{invdetail.discountPercentage}</td>
                                                    <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', fontSize: '12px', width: '10%', fontWeight: 'bold', textAlign: 'right' }}>
                                                        <input
                                                            type="number"
                                                            onChange={(e) =>
                                                                handleEdit(index, "AdditionalDiscountPercentage", e.target.value)
                                                            }
                                                            onClick={(e) => e.target.select()}
                                                            value={invdetail.AdditionalDiscountPercentage}
                                                            style={{ width: "100%", fontSize: "13px", fontWeight: 'bold', padding: "4px", textAlign: 'right', backgroundColor: '#FFF1DC' }}
                                                        />
                                                    </td>
                                                    <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', fontSize: '12px', width: '15%', fontWeight: 'bold', textAlign: 'right' }}>{invdetail.TotalAmount}</td>
                                                    {roleName == "SuperAdmin" && (
                                                        <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', marginTop: '-15px', width: '10%', textAlign: 'right' }}>
                                                            <IconButton style={{ padding: '8px', marginTop: '-10px' }} onClick={() => removeRecord(index)}>
                                                                <DeleteIcon style={{ color: '#CD5656', fontSize: '19px' }} />
                                                            </IconButton>
                                                        </td>
                                                    )}
                                                </tr>
                                            ))}
                                        </tbody>

                                        {/* Footer Section */}
                                        <tfoot>
                                            <tr style={{
                                                backgroundColor: '#27445D',
                                                position: 'sticky',
                                                bottom: 0,
                                                boxShadow: '0px -2px 5px rgba(0, 0, 0, 0.1)',
                                                zIndex: 2   // important so it stays above rows
                                            }}>
                                                <td style={{ padding: '2px', fontWeight: 'bold', textAlign: 'right', fontSize: "13px", backgroundColor: '#D3DAD9' }} colSpan={1}></td>
                                                <td style={{ padding: '2px', fontWeight: 'bold', textAlign: 'right', fontSize: "13px", backgroundColor: '#D3DAD9', color: 'black' }}>
                                                    <input
                                                        type="number"
                                                        value={invoicedeatils.reduce((sum, item) => sum + Number(item.Quantity || 0), 0)}
                                                        style={{ width: "100%", fontSize: "13px", fontWeight: 'bold', padding: "4px", textAlign: 'right', backgroundColor: '#D3DAD9', color: 'black', border: 'none' }}
                                                        readOnly
                                                    />
                                                </td>
                                                <td colSpan={3} style={{ padding: '2px', backgroundColor: '#D3DAD9' }}></td>
                                                <td style={{ padding: '2px', fontWeight: 'bold', textAlign: 'right', fontSize: "13px", backgroundColor: '#D3DAD9', color: 'black' }}>
                                                    {invoicedeatils.reduce((sum, item) => sum + Number(item.TotalAmount || 0), 0).toFixed(2)}
                                                </td>
                                                <td style={{ backgroundColor: '#D3DAD9' }}></td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </TableContainer>

                            </div>
                        </div>

                        <div className="w-full mb-2 flex" style={{ marginTop: '-0.90%' }}>

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-full mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Remarks
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.Remarks}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="REMARKS"
                                        name='Remarks'
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-full mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Remarks
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.Remarks}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Remarks"
                                        name='Remarks'
                                    />
                                </div>
                            )}

                        </div>

                    </div>
                </div>
            </div >
        </Fragment >
    );
};

export default NewSaleEdit;